import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-new-users-team-membership',
  templateUrl: './new-users-team-membership.component.html',
  styleUrls: ['./new-users-team-membership.component.scss'],
})
export class NewUsersTeamMembershipComponent {
  activatedRoute: any;

  modalLabel: any;
  teamMemberForm!: FormGroup;
  teamMemberData: any;
  teamList: any;
  isReadOnly!: boolean;
  submitted!: boolean;
  @Output() saveUsersTeamMembershipEvent = new EventEmitter<any>();
  roleListNew: any;
  selectTeam: any;
  selectRole: any;
  disableDropdown: any;

  constructor(private modal: CustomModalService, private formBuilder: FormBuilder) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.isReadOnly = this.activatedRoute == 'AdminManageUsers' ? false : true;
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.disableDropdown = this.modalLabel == 'Edit team membership' ? true : false;
    this.teamMemberData = this.modal?.modalService?.config?.initialState?.['newTeamMemberData'];

    const newRoleList = this.teamMemberData.roleItems;
    const newRoleListData = newRoleList;
    this.roleListNew = newRoleListData;
    this.roleListFunction();

    this.teamList = this.teamMemberData.teamItems;
    this.teamListFunction();
  }
  ngOnInit() {
    this.teamMemberForm = this.formBuilder.group({
      teamName: [null, Validators.required],
      roleName: [null, [Validators.required]],
    });
    this.setFormData();
  }
  async teamListFunction() {
    await this.teamList.map((item: any) => {
      if (item.id == this.teamMemberData.teamId) {
        return (this.selectTeam = item);
      }
    });
  }
  async roleListFunction() {
    await this.roleListNew.map((item: any) => {
      if (item.id == this.teamMemberData.roleId) {
        return (this.selectRole = item);
      }
    });
  }
  setFormData() {
    this.teamMemberForm.patchValue({ teamName: this.selectTeam, roleName: this.selectRole });
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  teamInputSearch(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  onSave() {
    this.submitted = true;
    if (
      this.teamMemberForm.controls['teamName'].value.name == '-- Select Team -- ' ||
      this.teamMemberForm.controls['roleName'].value.name == '-- Select Role Name -- ' ||
      this.teamMemberForm.invalid
    ) {
      this.submitted = true;
      return;
    } else {
      const data = {
        id: this.teamMemberData.id,
        userId: this.teamMemberData.userId || 0,
        roleId: this.teamMemberForm.controls['roleName'].value?.id || null,
        teamId: this.teamMemberForm.controls['teamName'].value?.id,
      };
      this.saveUsersTeamMembershipEvent.emit(data);
      this.modal.close();
    }
  }

  onClose() {
    this.modal.close();
  }
}
